import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { TESTIMONIALS } from "../data/testimonials";

const CourseTestimonials = () => (
  <section className="py-12 bg-slate-50" data-testid="course-testimonials">
    <div className="container mx-auto px-4 lg:px-8">
      <div className="text-center mb-8">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-primary">What our clients say</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <Card key={t.author} className="relative" data-testid={`testimonial-${i}`}>
            <CardContent className="p-6">
              <Quote className="absolute top-4 right-4 h-6 w-6 text-amber-200" />
              <div className="flex items-center gap-0.5 mb-3">
                {[1, 2, 3, 4, 5].map((r) => (
                  <Star key={r} className={`h-4 w-4 ${r <= t.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
                ))}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed mb-4">"{t.quote}"</p>
              <div className="border-t pt-3">
                <p className="font-semibold text-sm">{t.author}</p>
                <p className="text-xs text-muted-foreground">{[t.role, t.company].filter(Boolean).join(", ")}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default CourseTestimonials;
